import './App.css';
import React, { useState, useEffect } from 'react';
import { BackIcon } from './Icons';

function shuffle(array) {
  return [...array].sort(() => Math.random() - 0.5);
}

export default function PassiveLearningApp({ words, onBack }) {
  const [shuffledWords] = useState(shuffle(words));
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isFlipped, setIsFlipped] = useState(false);
  const [languageDirection, setLanguageDirection] = useState('pl-de');

  const sourceLang = languageDirection === 'pl-de' ? 'pl' : 'de';
  const targetLang = languageDirection === 'pl-de' ? 'de' : 'pl';

  const nextCard = () => {
    setCurrentIndex((prev) => (prev + 1) % shuffledWords.length);
    setIsFlipped(false);
  };

  const prevCard = () => {
    setCurrentIndex((prev) => (prev - 1 + shuffledWords.length) % shuffledWords.length);
    setIsFlipped(false);
  };

  const toggleLanguageDirection = () => {
    setLanguageDirection(prev => (prev === 'pl-de' ? 'de-pl' : 'pl-de'));
    setIsFlipped(false);
  };

  // Obsługa klawiszy strzałek
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'ArrowRight') nextCard();
      if (e.key === 'ArrowLeft') prevCard();
      if (e.key === ' ') {
        e.preventDefault(); // Zapobiegaj przewijaniu strony
        setIsFlipped(f => !f);
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [shuffledWords.length]); // Zależność, aby uniknąć problemów z domknięciem

  const currentWord = shuffledWords[currentIndex];

  return (
    <>
      <div className="flashcard-container passive-learning-container">
      <h1>👀 Ucz się</h1>
      <div className="language-toggle-container">
        <button onClick={toggleLanguageDirection} className="language-toggle-button">
          {languageDirection === 'pl-de' ? 'PL ➔ DE' : 'DE ➔ PL'}
        </button>
      </div>
      <div className={`card ${isFlipped ? 'is-flipped' : ''}`} onClick={() => setIsFlipped(!isFlipped)}>
        <div className="card-face card-front">{currentWord[sourceLang]}</div>
        <div className="card-face card-back">{currentWord[targetLang]}</div>
      </div>
      <div className="card-navigation">
        <button onClick={prevCard}>Poprzednie</button>
        <button onClick={nextCard}>Następne</button>
      </div>
      </div>
      <div className="floating-back-button"><button onClick={onBack}><BackIcon /></button></div>
    </>
  );
}
